<template>
    <a :href="source" class="btn btn-info" target="_blank">Videos tutoriales</a>
    <!-- <iframe 
        title="Optimo"
        src="https://www.youtube.com/embed/videoseries?list=PL7Jc77Wkwv0QkQCX2um2hmYXCG0GrTXfp" 
        class="mr-12" 
        style="width: 100%; height: 100vh; border: none; box-sizing: border-box;">
    </iframe> -->
    <!-- <iframe 
        title="Optimo" 
        src="https://www.youtube.com/embed/videoseries?list=PL7Jc77Wkwv0QkQCX2um2hmYXCG0GrTXfp" 
        width="100%" 
        height="640" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
    </iframe> -->
</template>
  
<script>
    export default {
      name: 'Ayuda',
    //   data () {
    //     return {
    //         source: 'https://youtube.com/playlist?list=PL7Jc77Wkwv0QkQCX2um2hmYXCG0GrTXfp'
    //     }
    //   }
        data: () => ({
            source: 'https://youtube.com/playlist?list=PL7Jc77Wkwv0QkQCX2um2hmYXCG0GrTXfp'
        })
    }
</script>
  